var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56622_22039)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56622_22039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H22V22H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56622_22039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1398 11.001C21.1376 11.9053 21.1274 12.8097 21.115 13.7139C21.1001 14.805 21.0832 15.8965 20.8096 16.9688C20.5227 18.0933 19.9568 19.0631 19.0764 19.781C18.1486 20.5376 17.0272 20.9353 15.8168 21.0089C14.2115 21.1065 12.6055 21.1451 10.9996 21.1413C9.39357 21.1451 7.78757 21.1065 6.1823 21.0089C4.97196 20.9353 3.85056 20.5376 2.92278 19.781C2.04235 19.0631 1.47645 18.0933 1.1895 16.9688C0.915879 15.8965 0.899036 14.805 0.884126 13.7139C0.871751 12.8097 0.86148 11.9053 0.859375 11.001C0.86148 10.0967 0.871751 9.1923 0.884126 8.28802C0.899036 7.19701 0.915879 6.10551 1.1895 5.03319C1.47645 3.90869 2.04235 2.93889 2.92278 2.22092C3.85056 1.46433 4.97196 1.06665 6.1823 0.993048C7.78757 0.895423 9.39357 0.856837 10.9996 0.860619C12.6055 0.856837 14.2115 0.895423 15.8168 0.993048C17.0272 1.06665 18.1486 1.46433 19.0764 2.22092C19.9568 2.93889 20.5227 3.90869 20.8096 5.03319C21.0832 6.10551 21.1001 7.19701 21.115 8.28802C21.1274 9.1923 21.1376 10.0967 21.1398 11.001Z",
    stroke: "#18181B",
    strokeWidth: 1.84895,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 11.001C15.4688 13.4927 13.4488 15.5127 10.957 15.5127C8.46527 15.5127 6.44531 13.4927 6.44531 11.001C6.44531 8.50922 8.46527 6.48926 10.957 6.48926C13.4488 6.48926 15.4688 8.50922 15.4688 11.001Z",
    stroke: "#18181B",
    strokeWidth: 1.84895,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 5.2002C18.2188 5.9121 17.6416 6.48926 16.9297 6.48926C16.2178 6.48926 15.6406 5.9121 15.6406 5.2002C15.6406 4.48829 16.2178 3.91113 16.9297 3.91113C17.6416 3.91113 18.2188 4.48829 18.2188 5.2002Z",
    fill: "#18181B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56622_22039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.4918950ecce568ae590458c5d7b3452b.svg";
export { ForwardRef as ReactComponent };